import * as React from "react";
import { useState, useEffect } from "react";
// import cargandoCard from "../../components/cargando-card";
// import sinAccesoCard from "../../components/sin-acceso-card";
import Modulo from "../../components/modulo";
import { useModulesSettings } from "./modules_settings";


export default function SettingsScreen() {

    const MODULES_SETTINGS = useModulesSettings();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            setCargandoPage(false);
            setTieneAccesoAlModulo(true);
        } catch (err) {
            setTieneAccesoAlModulo(false);
            console.log('iniciar err');
            console.log(err);
        }
    }

    const render = () => {
        try {
            // if (cargandoPage === true) {
            //     return cargandoCard();
            // }
            // if (tieneAccesoAlModulo === false) {
            //     return sinAccesoCard();
            // }
            return (
                <div className="flex flex-wrap gap-4 m-4">
                    {MODULES_SETTINGS.map((data) => Modulo(data))}
                </div>
            );
        } catch (err) {
            console.log('render err dashboard');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }


    return render();
};
